module.exports = __webpack_public_path__ + "static/media/anc3ru.4d95c231.pdf";